export const getStepsTranslated = (t) => [
  {
    id: "collect",
    number: t("landing.workflow.step_number_01"),
    title: t("landing.workflow.step_title_01"),
    description: t("landing.workflow.step_description_01"),
    icon: "feedback",
    accent: "#334768",
  },
  {
    id: "understand",
    number: t("landing.workflow.step_number_02"),
    title: t("landing.workflow.step_title_02"),
    description: t("landing.workflow.step_description_02"),
    icon: "analysis",
    accent: "#9B30C1",
  },
  {
    id: "report",
    number: t("landing.workflow.step_number_03"),
    title: t("landing.workflow.step_title_03"),
    description: t("landing.workflow.step_description_03"),
    icon: "report",
    accent: "#1A809E",
  },
];
